'use strict';

var angular = require('angular');
var dependencies = [];
module.exports = angular.module('AVRO.Widgets.InlineBarChart', dependencies).controller('InlineBarChartController', require('./controllers/InlineBarChartController')).directive('rmInlineBarChart', require('./directives/InlineBarChartDirective'));